import ConfirmationDeleteProduct from './ConfirmationDeleteProduct';

export default ConfirmationDeleteProduct;
